/* eslint-disable */
import { UserAdministrationDetailsCustomerDto, fixUserAdministrationDetailsCustomerDtoFromJson, fixUserAdministrationDetailsCustomerDtoToJson } from '../dto/user-administration-details-customer-dto';
import { UserAdministrationDetailsRoleDto, fixUserAdministrationDetailsRoleDtoFromJson, fixUserAdministrationDetailsRoleDtoToJson } from '../dto/user-administration-details-role-dto';

export interface UserAdministrationDetailsResponseDto {
  zvooveUserId: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  preferredLanguageCode: string | null;
  globalRoles: UserAdministrationDetailsRoleDto[];
  assignedCustomers: UserAdministrationDetailsCustomerDto[];
  twoFactorEnabled: boolean | null;
  isTrainingUser: boolean;
}

export const fixUserAdministrationDetailsResponseDtoFromJson = (dto?: UserAdministrationDetailsResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.globalRoles?.forEach((x, i, a) => fixUserAdministrationDetailsRoleDtoFromJson(a[i]));
  dto.assignedCustomers?.forEach((x, i, a) => fixUserAdministrationDetailsCustomerDtoFromJson(a[i]));
};

export const fixUserAdministrationDetailsResponseDtoToJson = (dto?: UserAdministrationDetailsResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.globalRoles?.forEach((x, i, a) => fixUserAdministrationDetailsRoleDtoToJson(a[i]));
  dto.assignedCustomers?.forEach((x, i, a) => fixUserAdministrationDetailsCustomerDtoToJson(a[i]));
};
